import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceLineBreaks',
})
export class ReplaceLineBreaks implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    return value.replace(/\\n/g, '\n').replace(/\&gt;/g, '>');
  }
}
